import { makeSimpleMapper } from "@/core/acl/mapperFactory";
import { zChargingStationSchemaDom, zChargingStationSchemaCreateDom, } from "@/types/chargingStation/chargingStation.domain";
import { zChargingStationSchemaDto, zChargingStationSchemaCreateDto, } from "@/types/chargingStation/chargingStation.dto";
import dayjs from "dayjs";
/**
 * Маппер для ChargingStation: DTO <-> Domain (1:1).
 */
export const ChargingStationMapper = makeSimpleMapper({
    dtoToDomain: (dto) => {
        return zChargingStationSchemaDom.parse({
            ...dto,
            manufactureDate: dto.manufactureDate ? dayjs(dto.manufactureDate) : null,
            warrantyEndDate: dto.warrantyEndDate ? dayjs(dto.warrantyEndDate) : null,
            lastMaintenanceDate: dto.lastMaintenanceDate ? dayjs(dto.lastMaintenanceDate) : null,
            nextMaintenanceDate: dto.nextMaintenanceDate ? dayjs(dto.nextMaintenanceDate) : null,
        });
    },
    domainToDto: (domain) => {
        return zChargingStationSchemaDto.parse({
            ...domain,
            manufactureDate: domain.manufactureDate?.toISOString(),
            warrantyEndDate: domain.warrantyEndDate?.toISOString(),
            lastMaintenanceDate: domain.lastMaintenanceDate?.toISOString(),
            nextMaintenanceDate: domain.nextMaintenanceDate?.toISOString(),
        });
    },
    dtoToCreateDto: (domain) => {
        return zChargingStationSchemaCreateDto.parse({
            ...domain,
            manufactureDate: domain.manufactureDate?.toISOString(),
            warrantyEndDate: domain.warrantyEndDate?.toISOString(),
            lastMaintenanceDate: domain.lastMaintenanceDate?.toISOString(),
            nextMaintenanceDate: domain.nextMaintenanceDate?.toISOString(),
        });
    },
    dtoToCreateDom: (dto) => {
        return zChargingStationSchemaCreateDom.parse({
            ...dto,
            manufactureDate: dto.manufactureDate ? dayjs(dto.manufactureDate) : null,
            warrantyEndDate: dto.warrantyEndDate ? dayjs(dto.warrantyEndDate) : null,
            lastMaintenanceDate: dto.lastMaintenanceDate ? dayjs(dto.lastMaintenanceDate) : null,
            nextMaintenanceDate: dto.nextMaintenanceDate ? dayjs(dto.nextMaintenanceDate) : null,
        });
    },
});
